import { useTranslation } from '@crehana/i18n';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import type { CuiOptionType } from '@crehana/ui';

const useTranslateCuiOptions = (
  options: CuiOptionType<string | boolean>[],
): CuiOptionType<string | boolean>[] => {
  const { t } = useTranslation();
  return options.map(option => ({ ...option, label: t(option.label) }));
};

export default useTranslateCuiOptions;
